/**
 * Controller: OrdersCheckoutAddEventModal
 */
angular.module('acme.view.application.orders.checkout.addEventModal.controllers', [
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.permissions',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.common.service.templates.helpers'
])
  .controller('OrdersCheckoutAddEventModalController', ['$scope', '$timeout', '$filter', '$state', '$uibModalInstance', '$q', 'events', 'accountId', 'startTime', 'ApiService', 'HelpersService', 'PermissionsService', 'CalendarService', 'GridDefinitionFactory', 'GridStateFactory', 'TemplatesHelpersService', 'UserPreferencesService', function ($scope, $timeout, $filter, $state, $uibModalInstance, $q, events, accountId, startTime, ApiService, HelpersService, PermissionsService, CalendarService, GridDefinitionFactory, GridStateFactory, TemplatesHelpersService, UserPreferencesService) {

    $scope.errors = [];

    $scope.ordersCheckoutAddEventModal = {
      
      gridDefinition: new GridDefinitionFactory(),
      gridState: new GridStateFactory(),

      startTime: '',
      endTime: '',
      viewId: '',
      searchQuery: '',
      timeFormat: HelpersService.dateFormats.standardTime,
      
      isCSR: false,
      isLoaded: false,
      
      eventQueue: {},
      selectedRows: {},
      
      eventListGridName: $state.current.name+'.grid0',
      
      optionsOverride: {
        pageSize: 10,
        paginationPageSize: 10,
        paginationPageSizes: [10, 25],
        data: 'ordersCheckoutAddEventModal.model',
        multiSelect: true,
        noUnselect: false,
        enableRowSelection: true,
        useAccessibleGrid: true,
        columnDefs: [
          {
            field: 'formattedStartTime',
            width: 100,
            displayName: 'Start Time',
            sort: {
              direction: 'asc'
            },
            cellTemplate: '<div class="ui-grid-cell-contents text-center"><span data-ng-style="row.entity.colorCategoryStyle"></span> {{ row.entity.formattedStartTime }} <span class="sr-only"> Event starts at {{ row.entity.formattedStartTime }}</span></div>'
          },
          {
            field: 'startDate',
            displayName: 'Date',
            width: 80,
            visible: false,
            cellFilter: 'date: "'+HelpersService.dateFormats.shortDate+'"',
            cellFormatter: function(item) {
              return $filter('date')(item.value, HelpersService.dateFormats.shortDate);
            }
          },
          {
            field: 'name',
            displayName: 'Event Name',
            visible: true
          },
          {
            field: 'organization.name',
            displayName: 'Organization Name',
            visible: false
          },
          {
            field: 'scheduleName',
            displayName: 'Schedule Name',
            visible: false
          },
          {
            field: 'resourceRequestDisplay',
            displayName: 'Resources',
            visible: false,
            minWidth: 150,
            colId: 'requestSummary'
          },
          {
            field: 'sold',
            displayName: 'Sold',
            width: 60,
            visible: false
          },
          {
            field: 'reserved',
            displayName: 'Reserved',
            width: 80,
            visible: false
          },
          {
            field: 'available',
            displayName: 'Available',
            width: 100,
            visible: true
          },
          {
            field: 'checkedIn',
            displayName: 'Checked In',
            width: 90,
            visible: false
          }
        ],
        appScopeProvider: {
          onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.ordersCheckoutAddEventModal.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDataGridSortChange: function(grid, columns, page) {
            $scope.ordersCheckoutAddEventModal.onDataGridSortChange(grid, columns, page);
          },
          onDataGridSelectionChange: function(row, e) {
            $scope.ordersCheckoutAddEventModal.onDataGridSelectionChange(row, e);
          }
        }
      },    
      
      init: function() {
        var startDate = this.getToday(startTime);
        
        this.isCSR = PermissionsService.check('CSR');
        this.viewId = $state.current.name;
        
        if (CalendarService.current.eventsStartTimeTracker) {
          this.startDate = new Date(CalendarService.current.eventsStartTimeTracker.getFullYear(), CalendarService.current.eventsStartTimeTracker.getMonth(), CalendarService.current.eventsStartTimeTracker.getDate(), 0, 0, 0);
        }else {
          this.startDate = startDate;
        }
        
        this.startTime = CalendarService.toISO8601(this.startDate);
        
        this.gridDefinition.init(this.eventListGridName, this.optionsOverride, this.viewId, true);

        $scope.$watch('ordersCheckoutAddEventModal.startDate', this.onStartDateUpdate);
        $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', this.initData));

      },
      
      initData: function(e, data) {
        var self = $scope.ordersCheckoutAddEventModal, 
          props = self.gridDefinition.getGridState();
        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.search();
      },
      
      search: function() {
        this.isLoaded = false;
        if (this.gridDefinition.userPreferencesLoaded) {
          this.getEvents();
        }
      },
      
      getToday: function(_date) {
        var date = (_date) ? new Date(_date) : new Date();
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        return date;
      },

      getEvents: function() {
        var params = {
          startTime: CalendarService.toISO8601(this.startTime),
          endTime: CalendarService.toISO8601(this.endTime)
        };
        if (this.isCSR) {
          params.saleChannel = 'customerRep';
        }
        ApiService.event.search($.extend(params, this.gridState.getGridState())).then(this.success.getEvents, this.error.getEvents);
      },

      onStartDateUpdate: function(n, o) {
        
        var self = $scope.ordersCheckoutAddEventModal,
        startDate = self.startDate,
        endDate = new Date(self.startDate);
        
        startDate.setHours(0);
        startDate.setMinutes(0);
        startDate.setSeconds(0);
        
        endDate.setHours(23);
        endDate.setMinutes(23);
        endDate.setSeconds(23);
        
        self.startTime = CalendarService.toISO8601(startDate);
        self.endTime = CalendarService.toISO8601(endDate);
        self.getEvents();

      },

      hasEvents: function() {
        return ($scope.model.events instanceof Array && $scope.model.events.length > 0);
      },

      handleEvent: function(event) {
        var self = $scope.ordersCheckoutAddEventModal;
        if(self.eventQueue[event.id]) {
          delete self.eventQueue[event.id];
        } else {
          self.eventQueue[event.id] = event;
        }
      },
      
      process: function(events) {
        var i, ii,
          startDate,
          endDate,
          j, jj;

        for (i=0,ii=events.length;i<ii;i++) {
          startDate = CalendarService.parseDate(events[i].startTime);
          endDate = CalendarService.parseDate(events[i].endTime);

          events[i].startDate = startDate;
          events[i].formattedEndTime = $filter('date')(endDate, HelpersService.dateFormats.standardTime);
          events[i].formattedStartTime = $filter('date')(startDate, HelpersService.dateFormats.standardTime);
          events[i].isCancelled = (events[i].state && events[i].state === 'cancelled') ? true : false;
          events[i].resourceRequestDisplay = this.getEventRequestsDisplay(events[i]);
          if (events[i].colorCategory && events[i].colorCategory.textColor) {
            events[i].colorCategoryStyle = TemplatesHelpersService.getColorCategoryStyle(events[i].colorCategory);
          }

          if (events[i].offSchedule) {
            events[i].scheduleName = 'None (from Order Request)';
          }

          if (events[i].manuallyDeleted) {
            events[i].available = events[i].available ||  0;

            if (!events[i].sold) {
              events[i].sold = events[i].soldQuantity || 0;
            }

            if (!events[i].checkedIn) {
              events[i].checkedIn = events[i].checkInCount || 0;
            }
          }

        }

        return events;
      },
      
      getEventRequestsDisplay: function(event) {

        var r = 'No requests',
            personnelRequests = '',
            equipmentRequests = '',
            placesRequests = '';

        if (event.hasOwnProperty('requestSummary') && event.requestSummary.hasResourceRequests) {
          personnelRequests = this.getRequestsForCategory(event, 'people');
          equipmentRequests = this.getRequestsForCategory(event, 'equipment');
          placesRequests = this.getRequestsForCategory(event, 'place');

          if (personnelRequests || equipmentRequests || placesRequests) {
            r = [personnelRequests,equipmentRequests,placesRequests].filter(function(request){
                 return request;
            }).join(', ');
          }
        }

        return r;
      },
      
      getRequestsForCategory: function(event, category) {
        var categorySuffix,
          fulfilled = 0,
          total = 0,
          requests,
          r = '';

        if (category === 'place') {
          categorySuffix = 'Places';
        }else {
          categorySuffix = HelpersService.cap(category);
        }

        if (event.requestSummary.hasOwnProperty(category)) {
          fulfilled = event.requestSummary[category].fulfilledRequestsCount ? event.requestSummary[category].fulfilledRequestsCount : 0;
          total = event.requestSummary[category].totalRequestsCount ? (event.requestSummary[category].totalRequestsCount) : 0;
          requests = (total) ?  (fulfilled + '/' + total) : '';
          // Show resource name if total and fulfilled is 1 and only 1
          if (fulfilled === total && fulfilled === 1) {
            if (event.requestSummary[category].resourceNames instanceof Array &&
                event.requestSummary[category].resourceNames[0]) {
              r = event.requestSummary[category].resourceNames[0];
            }
          }else {
            r = requests ? requests + ' ' + categorySuffix : '';
          }
        }

        return r;
      },
      
      getEventIds: function(events) {
        var r = [];
        angular.forEach(events, function(_event) {
          if(_event.selected) {
            r.push(_event.data.id);
          }
        });
        return r;
      },
      
      query: function() {
        var self = $scope.ordersCheckoutAddEventModal;
        self.gridState.setPropertyValue('search', self.searchQuery);
        $scope.$broadcast('DataGrid::Search', {name: self.eventListGridName});
      },      
      
      onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
        var self = $scope.ordersCheckoutAddEventModal;
        self.gridState.updateGridState(newPage, pageSize);
        if (sortField) {
          self.gridState.updateGridState(null, null, sortField, null);
        }
        if(sortDirection) {
          self.gridState.updateGridState(null, null, null, sortDirection);
        }
        self.search();
      },
      
      onDataGridSortChange: function(grid, columns, page) {
        var self = $scope.ordersCheckoutAddEventModal, data = columns[0];
        self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
        self.search();
      },
      
      onDataGridSelectionChange: function(row) {
        var i, ii,
          self = $scope.ordersCheckoutAddEventModal;

        if (row instanceof Array) {
          for (i=0,ii=data.length;i<ii;i++) {
            self.selectedRows[row[i].entity.id] = { selected: row[i].isSelected, data: row[i].entity };
            row[i].entity.active = row[i].isSelected;
          }
        } else if(row instanceof Object && row.isSelected !== undefined) {
          self.selectedRows[row.entity.id] = { selected: row.isSelected, data: row.entity };
          row.entity.active = row.isSelected;
        }
      },
      
      processEventList: function(events) {
        return events.map(function(_event) { return _event.data.payload; });
      },

      success: {
        getEvents: function(response) {
          var self = $scope.ordersCheckoutAddEventModal;

          console.log('OrdersCheckoutAddEventModalController::success::getEvents', response);

          self.model = self.process(response.data.payload.list);          
          
          self.isLoaded = true;
          self.gridDefinition.isLoaded = true;          
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.length, totalItems: response.data.payload.pagination.count});
          }, 10);
        }
      },

      error: {
        getEvents: function(response) {}
      }
    };

    $scope.init = function() {
      $scope.ordersCheckoutAddEventModal.init();
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.trim = function(s) {
      return s.replace(/\s+/g, '').toLowerCase();
    };

    $scope.done = function() {
      var events = $scope.ordersCheckoutAddEventModal.getEventIds($scope.ordersCheckoutAddEventModal.selectedRows);
      $scope.errors = [];

      if (events.length) {
        $scope.success(events);
      }else{
        $scope.errors.push({ message: 'No event selected. Select an event to continue.' });
      }
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function (eventIds) {
      var i,ii,
          self = $scope.ordersCheckoutAddEventModal,
          model = $scope.model,
          events = [],
          promises = [];
          
          
      
      if (accountId) {
        for (i = 0, ii = eventIds.length; i < ii; i++) {
          promises.push(ApiService.partners.reseller.event({ accountId: accountId, eventId: eventIds[i] }));
        }        
        $q.allSettled(promises).then(function(_events) {
          events = self.processEventList(_events);
          $uibModalInstance.close(events);
        }, function() {
          $scope.errors.push({ message: 'Unable to retrieve event' });          
        });
      } else {        
        for (i = 0, ii = eventIds.length; i < ii; i++) {
          promises.push(ApiService.program.instances.detail(eventIds[i]));
        }         
        $q.allSettled(promises).then(function(_events) {
          events = self.processEventList(_events);      
          $uibModalInstance.close(events);
        }, function() {
          $scope.errors.push({ message: 'Unable to retrieve event' });          
        });
      }
    };

    $scope.init();

}]);